module.exports = "<h1>Edit organization</h1>\n\n<div [hidden]=\"!error\" class=\"alert alert-danger\" role=\"alert\">\n  <strong>Error:</strong> {{error}}\n</div>\n\n<div [hidden]=\"!success\" class=\"alert alert-success\" role=\"alert\">\n  <strong>Success!</strong> Update complete. <a href=\"#/organizations\">View organizations</a>\n</div>\n\n<org-form *ngIf=\"model\" [model]=\"model\" [loading]=\"loading\" (onSubmit)=\"editOrg($event)\"></org-form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/orgs/edit.org.component.html
// module id = 879
// module chunks = 1